export default "__VITE_ASSET__CokqBO48__"